/** Rechtstexte liegen auf der Website und werden aus der App in einem neuen Tab geöffnet. */
export const IMPRESSUM_URL = 'https://www.meisterpfad.de/impressum';
